import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Backdrop, Box, Card, CardActions, CardContent, CardHeader, IconButton, Modal as MuiModal, Paper, styled, useMediaQuery, useTheme, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../atoms/Button';
import { LoadingIndicator } from '../../atoms/LoadingIndicator';
import ShortcutKeyButton from '../ShortcutKeyButton';
const ActionButtonContainer = styled(Box) `
  display: flex;
  flex: 1;
  margin: 0 !important;
  gap: 8px;
`;
export const Modal = ({ content, title, actions, isOpen, onClose, hideCloseButton = false, isLoading = false, height = 'unset', width = '600px', disableHeaderTypography = false, sx = {}, }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));
    const actionButtons = {
        left: [],
        center: [],
        right: [],
    };
    actions?.forEach(({ label, color, position = 'right', ...action }) => {
        const props = {
            label,
            color: color ?? 'primary',
            margin: isDesktop ? '4px' : '0',
            fullWidth: !isDesktop,
            ...action,
        };
        const button = action.shortcutKey ? (_jsx(ShortcutKeyButton, { keyToPress: action.shortcutKey, ...props }, `modal-action-${label}`)) : (_jsx(Button, { ...props }, `modal-action-${label}`));
        actionButtons[position].push(button);
    });
    const handleClose = () => {
        onClose();
    };
    const closeButton = !hideCloseButton ? (_jsx(IconButton, { "aria-label": "settings", onClick: handleClose, children: _jsx(CloseIcon, {}) })) : undefined;
    if (isLoading) {
        return (_jsx(Backdrop, { sx: { zIndex: theme.zIndex.drawer + 1 }, open: isOpen, children: _jsx(LoadingIndicator, {}) }));
    }
    return (_jsx(MuiModal, { open: isOpen, onClose: handleClose, sx: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            ...sx,
        }, children: _jsx(Card, { className: "ModalCard", sx: {
                width: isDesktop ? width : '100vw',
                height: isDesktop ? height : 'calc(var(--vh, 1vh) * 100)', // Use full viewport height on mobile
            }, children: _jsxs(Paper, { color: 'background.paper-elevation-1', sx: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }, children: [_jsxs("div", { children: [_jsx(CardHeader, { disableTypography: disableHeaderTypography, title: title, action: closeButton }), _jsx(CardContent, { children: content })] }), actions.length > 0 &&
                        _jsxs(CardActions, { sx: {
                                flexDirection: isDesktop ? 'row' : 'column',
                                alignItems: isDesktop ? 'unset' : 'stretch',
                                padding: '16px',
                            }, children: [actionButtons.left.length > 0 && (_jsx(ActionButtonContainer, { sx: { justifyContent: 'start' }, children: actionButtons.left })), actionButtons.center.length > 0 && (_jsx(ActionButtonContainer, { sx: { justifyContent: 'center' }, children: actionButtons.center })), actionButtons.right.length > 0 && (_jsx(ActionButtonContainer, { sx: { justifyContent: 'end' }, children: actionButtons.right }))] })] }) }) }));
};
//# sourceMappingURL=index.js.map